
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("52xdm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3ab6e7588760c130$export$2e2bcd8739ae039; });
/* blanket.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gLRVV = parcelRequire("gLRVV");

var $iSvIT = parcelRequire("iSvIT");

var $ecLC4 = parcelRequire("ecLC4");
var $g2S1g = parcelRequire("g2S1g");

var $1PRJ2 = parcelRequire("1PRJ2");

var $4OZuI = parcelRequire("4OZuI");

var $41imr = parcelRequire("41imr");

function $3ab6e7588760c130$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3ab6e7588760c130$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3ab6e7588760c130$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gLRVV.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3ab6e7588760c130$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3ab6e7588760c130$var$packageName = "@atlaskit/blanket";
var $3ab6e7588760c130$var$packageVersion = "15.0.0";
var $3ab6e7588760c130$var$analyticsAttributes = {
    componentName: "blanket",
    packageName: $3ab6e7588760c130$var$packageName,
    packageVersion: $3ab6e7588760c130$var$packageVersion
};
var $3ab6e7588760c130$var$baseStyles = null;
var $3ab6e7588760c130$var$shouldAllowClickThroughStyles = null;
var $3ab6e7588760c130$var$invisibleStyles = null;
/**
 * __Blanket__
 *
 * A Blanket provides the overlay layer for components such as a modal dialog or a tooltip
 *
 * - [Examples](https://atlaskit.atlassian.com/examples/design-system/blanket/basic-usage)
 */ var $3ab6e7588760c130$var$Blanket = /*#__PURE__*/ (0, $iSvIT.memo)(/*#__PURE__*/ (0, $iSvIT.forwardRef)(function Blanket(_ref, ref) {
    var _ref$shouldAllowClick = _ref.shouldAllowClickThrough, shouldAllowClickThrough = _ref$shouldAllowClick === void 0 ? false : _ref$shouldAllowClick, _ref$isTinted = _ref.isTinted, isTinted = _ref$isTinted === void 0 ? false : _ref$isTinted, _ref$onBlanketClicked = _ref.onBlanketClicked, onBlanketClicked = _ref$onBlanketClicked === void 0 ? (0, $4OZuI.default) : _ref$onBlanketClicked, testId = _ref.testId, children = _ref.children, analyticsContext = _ref.analyticsContext;
    var mouseDownTarget = (0, $iSvIT.useRef)(null);
    var onBlanketClickedWithAnalytics = (0, $1PRJ2.usePlatformLeafEventHandler)($3ab6e7588760c130$var$_objectSpread({
        fn: onBlanketClicked,
        action: "clicked",
        analyticsData: analyticsContext
    }, $3ab6e7588760c130$var$analyticsAttributes));
    var blanketClickOutsideChildren = (0, $iSvIT.useCallback)(function(e) {
        return e.currentTarget === e.target && mouseDownTarget.current === e.target ? onBlanketClickedWithAnalytics(e) : undefined;
    }, [
        onBlanketClickedWithAnalytics
    ]);
    var onClick = shouldAllowClickThrough ? undefined : blanketClickOutsideChildren;
    var onMouseDown = (0, $iSvIT.useCallback)(function(e) {
        mouseDownTarget.current = e.target;
    }, []);
    return /*#__PURE__*/ $iSvIT.createElement("div", {
        role: "presentation",
        onClick: onClick,
        onMouseDown: onMouseDown,
        "data-testid": testId,
        ref: ref,
        className: (0, $ecLC4.default)([
            "_1r04idpf _kqsw1n9t _1pbybfng _bfhk705f _18m91wug _lcxv1wug",
            shouldAllowClickThrough && "_lcxvglyw",
            !isTinted && "_bfhk1j28"
        ]),
        style: {
            "--_10avjlk": (0, $g2S1g.default)("var(--ds-blanket, ".concat((0, $41imr.N100A), ")"))
        }
    }, children);
}));
$3ab6e7588760c130$var$Blanket.displayName = "Blanket";
var $3ab6e7588760c130$export$2e2bcd8739ae039 = $3ab6e7588760c130$var$Blanket;

});
parcelRegister("gLRVV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c35adf21fccd2072$export$2e2bcd8739ae039; });

var $39bLe = parcelRequire("39bLe");
function $c35adf21fccd2072$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $39bLe.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("39bLe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $24ab55cacd2ffee4$export$2e2bcd8739ae039; });

var $evu92 = parcelRequire("evu92");

var $3MuJa = parcelRequire("3MuJa");
function $24ab55cacd2ffee4$export$2e2bcd8739ae039(t) {
    var i = (0, $3MuJa.default)(t, "string");
    return "symbol" == (0, $evu92.default)(i) ? i : i + "";
}

});
parcelRegister("evu92", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8fb581648d814b8$export$2e2bcd8739ae039; });
function $a8fb581648d814b8$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $a8fb581648d814b8$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a8fb581648d814b8$export$2e2bcd8739ae039(o);
}

});

parcelRegister("3MuJa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2c0db0a868d42c88$export$2e2bcd8739ae039; });

var $evu92 = parcelRequire("evu92");
function $2c0db0a868d42c88$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $evu92.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $evu92.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("ecLC4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a5771ea84e375501$export$2e2bcd8739ae039; });
const $a5771ea84e375501$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $a5771ea84e375501$var$ATOMIC_GROUP_LENGTH = 5;
function $a5771ea84e375501$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(" ") === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(" ");
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $a5771ea84e375501$var$UNDERSCORE_UNICODE ? $a5771ea84e375501$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = "";
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + " ";
    }
    return str.slice(0, -1);
}

});

parcelRegister("g2S1g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bae6bc5d268579a7$export$2e2bcd8739ae039; });
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $bae6bc5d268579a7$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return "var(--c-, )";
}

});

parcelRegister("1PRJ2", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $15643a977b5a0f5c$export$a4687b0234b40e28; });

var $gLRVV = parcelRequire("gLRVV");

var $iSvIT = parcelRequire("iSvIT");

var $7NbUq = parcelRequire("7NbUq");

var $67lsh = parcelRequire("67lsh");
function $15643a977b5a0f5c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $15643a977b5a0f5c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $15643a977b5a0f5c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gLRVV.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $15643a977b5a0f5c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $15643a977b5a0f5c$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $7NbUq.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $67lsh.useTrackedRef)(analyticsData);
    var fnRef = (0, $67lsh.useTrackedRef)(fn);
    var handler = (0, $iSvIT.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $15643a977b5a0f5c$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("7NbUq", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $5ac658ebed47bba6$export$5bf35293e545f20c; });

var $6LIwV = parcelRequire("6LIwV");

var $7mr9U = parcelRequire("7mr9U");

var $1QaKl = parcelRequire("1QaKl");
function $5ac658ebed47bba6$export$5bf35293e545f20c() {
    var analyticsContext = (0, $1QaKl.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $6LIwV.useCallbackOne)(function(payload) {
        return new (0, $7mr9U.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("7mr9U", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $55bfa7a812165b3d$export$2e2bcd8739ae039; });

var $jObrW = parcelRequire("jObrW");

var $eJHTB = parcelRequire("eJHTB");

var $aCtuY = parcelRequire("aCtuY");

var $kAG3c = parcelRequire("kAG3c");

var $8RRS6 = parcelRequire("8RRS6");

var $grof2 = parcelRequire("grof2");

var $dICpU = parcelRequire("dICpU");

var $gLRVV = parcelRequire("gLRVV");

var $8NUKI = parcelRequire("8NUKI");
function $55bfa7a812165b3d$var$_callSuper(t, o, e) {
    return o = (0, $8RRS6.default)(o), (0, $kAG3c.default)(t, $55bfa7a812165b3d$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $8RRS6.default)(t).constructor) : o.apply(t, e));
}
function $55bfa7a812165b3d$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($55bfa7a812165b3d$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $55bfa7a812165b3d$var$_superPropGet(t, o, e, r) {
    var p = (0, $grof2.default)((0, $8RRS6.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $55bfa7a812165b3d$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $55bfa7a812165b3d$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $55bfa7a812165b3d$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, $eJHTB.default)(this, UIAnalyticsEvent);
        _this = $55bfa7a812165b3d$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, $gLRVV.default)(_this, "_isUIAnalyticsEvent", true);
        (0, $gLRVV.default)(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, $jObrW.default)(_this.context);
            var handlers = (0, $jObrW.default)(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, $gLRVV.default)(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, $dICpU.default)(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, $aCtuY.default)(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $55bfa7a812165b3d$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $8NUKI.default));

});
parcelRegister("jObrW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e6bb91805f722845$export$2e2bcd8739ae039; });

var $3uTtl = parcelRequire("3uTtl");

var $g23oi = parcelRequire("g23oi");

var $ciCO0 = parcelRequire("ciCO0");

var $bE5xT = parcelRequire("bE5xT");
function $e6bb91805f722845$export$2e2bcd8739ae039(r) {
    return (0, $3uTtl.default)(r) || (0, $g23oi.default)(r) || (0, $ciCO0.default)(r) || (0, $bE5xT.default)();
}

});
parcelRegister("3uTtl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $28bf3415abb3a24c$export$2e2bcd8739ae039; });

var $a2X0U = parcelRequire("a2X0U");
function $28bf3415abb3a24c$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $a2X0U.default)(r);
}

});
parcelRegister("a2X0U", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7507de2c1f7d329f$export$2e2bcd8739ae039; });
function $7507de2c1f7d329f$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("g23oi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $babf769cccb91b63$export$2e2bcd8739ae039; });
function $babf769cccb91b63$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("ciCO0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f45447396f6212e$export$2e2bcd8739ae039; });

var $a2X0U = parcelRequire("a2X0U");
function $8f45447396f6212e$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $a2X0U.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $a2X0U.default)(r, a) : void 0;
    }
}

});

parcelRegister("bE5xT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87a7bb5fcfb07324$export$2e2bcd8739ae039; });
function $87a7bb5fcfb07324$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("eJHTB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aba751772ee9cdc2$export$2e2bcd8739ae039; });
function $aba751772ee9cdc2$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("aCtuY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7bb455cf3d4c1d97$export$2e2bcd8739ae039; });

var $39bLe = parcelRequire("39bLe");
function $7bb455cf3d4c1d97$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $39bLe.default)(o.key), o);
    }
}
function $7bb455cf3d4c1d97$export$2e2bcd8739ae039(e, r, t) {
    return r && $7bb455cf3d4c1d97$var$_defineProperties(e.prototype, r), t && $7bb455cf3d4c1d97$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("kAG3c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $efd7c9c9f3f16f99$export$2e2bcd8739ae039; });

var $evu92 = parcelRequire("evu92");

var $l5AHL = parcelRequire("l5AHL");
function $efd7c9c9f3f16f99$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $evu92.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $l5AHL.default)(t);
}

});
parcelRegister("l5AHL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f5a68969cad4ceaf$export$2e2bcd8739ae039; });
function $f5a68969cad4ceaf$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("8RRS6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $674d0fc31a50dc95$export$2e2bcd8739ae039; });
function $674d0fc31a50dc95$export$2e2bcd8739ae039(t) {
    return $674d0fc31a50dc95$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $674d0fc31a50dc95$export$2e2bcd8739ae039(t);
}

});

parcelRegister("grof2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf81f8d535c0eaa6$export$2e2bcd8739ae039; });

var $c4IrC = parcelRequire("c4IrC");
function $bf81f8d535c0eaa6$export$2e2bcd8739ae039() {
    return $bf81f8d535c0eaa6$export$2e2bcd8739ae039 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = (0, $c4IrC.default)(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $bf81f8d535c0eaa6$export$2e2bcd8739ae039.apply(null, arguments);
}

});
parcelRegister("c4IrC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ca8557ff8489a37$export$2e2bcd8739ae039; });

var $8RRS6 = parcelRequire("8RRS6");
function $8ca8557ff8489a37$export$2e2bcd8739ae039(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = (0, $8RRS6.default)(t)););
    return t;
}

});


parcelRegister("dICpU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9fcd2f3b3a14b2bf$export$2e2bcd8739ae039; });

var $eazMz = parcelRequire("eazMz");
function $9fcd2f3b3a14b2bf$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $eazMz.default)(t, e);
}

});
parcelRegister("eazMz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a50dc186249673e7$export$2e2bcd8739ae039; });
function $a50dc186249673e7$export$2e2bcd8739ae039(t, e) {
    return $a50dc186249673e7$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $a50dc186249673e7$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("8NUKI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $668eec2f6d97766c$export$2e2bcd8739ae039; });

var $evu92 = parcelRequire("evu92");

var $eJHTB = parcelRequire("eJHTB");

var $aCtuY = parcelRequire("aCtuY");

var $gLRVV = parcelRequire("gLRVV");
function $668eec2f6d97766c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $668eec2f6d97766c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $668eec2f6d97766c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gLRVV.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $668eec2f6d97766c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $668eec2f6d97766c$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $668eec2f6d97766c$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $668eec2f6d97766c$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, $eJHTB.default)(this, AnalyticsEvent);
        (0, $gLRVV.default)(this, "_isAnalyticsEvent", true);
        (0, $gLRVV.default)(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $668eec2f6d97766c$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, $aCtuY.default)(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, $evu92.default)(updater) === "object") this.payload = $668eec2f6d97766c$var$_objectSpread($668eec2f6d97766c$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("1QaKl", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $1572fbce33c997e0$export$d1f587f82ad51c4; });

var $iSvIT = parcelRequire("iSvIT");

var $lEO1D = parcelRequire("lEO1D");
var $1572fbce33c997e0$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $iSvIT.useContext)((0, $lEO1D.default));
};

});


parcelRegister("67lsh", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $47440a13bcaa3ee2$export$1d27a74659855e44; });

var $iSvIT = parcelRequire("iSvIT");
var $47440a13bcaa3ee2$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $iSvIT.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("41imr", function(module, exports) {

$parcel$export(module.exports, "N100A", function () { return $2ed57f8980281ebc$export$486ab785e4bac3c6; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $2ed57f8980281ebc$export$4b84fd0e2c617bd = "#FFEBE6";
var $2ed57f8980281ebc$export$b34b069eff244586 = "#FFBDAD";
var $2ed57f8980281ebc$export$be802dd0d8b57f35 = "#FF8F73";
var $2ed57f8980281ebc$export$60847d42f9da92a6 = "#FF7452";
var $2ed57f8980281ebc$export$4a7404f376229999 = "#FF5630";
var $2ed57f8980281ebc$export$2010d0fb4295b346 = "#DE350B";
var $2ed57f8980281ebc$export$2837b5a1a71d5c02 = "#BF2600";
var $2ed57f8980281ebc$export$8d9596b529bbb9cf = "#FFFAE6";
var $2ed57f8980281ebc$export$41060a744ab0b7ae = "#FFF0B3";
var $2ed57f8980281ebc$export$1cc05bbbf340e559 = "#FFE380";
var $2ed57f8980281ebc$export$5aae31392d72caaa = "#FFC400";
var $2ed57f8980281ebc$export$c6930421db9fa514 = "#FFAB00";
var $2ed57f8980281ebc$export$59619663aa6500fb = "#FF991F";
var $2ed57f8980281ebc$export$874739ea9e379ab6 = "#FF8B00";
var $2ed57f8980281ebc$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $2ed57f8980281ebc$export$69a3bf21b9686c2b = "#ABF5D1";
var $2ed57f8980281ebc$export$afbce1382ec95f73 = "#79F2C0";
var $2ed57f8980281ebc$export$747d86715d4175de = "#57D9A3";
var $2ed57f8980281ebc$export$940e1f69e873f202 = "#36B37E";
var $2ed57f8980281ebc$export$a49394138f7b8e85 = "#00875A";
var $2ed57f8980281ebc$export$6fa04827ac68a4fb = "#006644";
var $2ed57f8980281ebc$export$226de0355ed012f8 = "#DEEBFF";
var $2ed57f8980281ebc$export$8c13c2ee36917869 = "#B3D4FF";
var $2ed57f8980281ebc$export$ecfc1dff386a3e7a = "#4C9AFF";
var $2ed57f8980281ebc$export$215b7063051591f1 = "#2684FF";
var $2ed57f8980281ebc$export$e62e8919cca44969 = "#0065FF";
var $2ed57f8980281ebc$export$b3de0ae08da2ce64 = "#0052CC";
var $2ed57f8980281ebc$export$a6ee3d71bc067634 = "#0747A6";
var $2ed57f8980281ebc$export$67f15409e87642a1 = "#669DF1";
var $2ed57f8980281ebc$export$f0539dbc42dbb067 = "#8FB8F6";
var $2ed57f8980281ebc$export$363e4475840015bb = "#EAE6FF";
var $2ed57f8980281ebc$export$4b0a4417ed59760f = "#C0B6F2";
var $2ed57f8980281ebc$export$6011520a64d9a187 = "#998DD9";
var $2ed57f8980281ebc$export$a7175d4e9206bc80 = "#8777D9";
var $2ed57f8980281ebc$export$b48405b95304b5a1 = "#6554C0";
var $2ed57f8980281ebc$export$c71e4279dd54a18d = "#5243AA";
var $2ed57f8980281ebc$export$147899de772240ec = "#403294";
var $2ed57f8980281ebc$export$2cf711fe14c66f06 = "#E6FCFF";
var $2ed57f8980281ebc$export$7a8f4d33f6f9772c = "#B3F5FF";
var $2ed57f8980281ebc$export$776c9c497ef08533 = "#79E2F2";
var $2ed57f8980281ebc$export$69cb3ca10c1e330e = "#00C7E6";
var $2ed57f8980281ebc$export$9dc1ef0f3f48059b = "#00B8D9";
var $2ed57f8980281ebc$export$7c835c78b6fcdef8 = "#00A3BF";
var $2ed57f8980281ebc$export$6036577f95c3877e = "#008DA6";
var $2ed57f8980281ebc$export$29a4f05edc054374 = "#FFFFFF";
var $2ed57f8980281ebc$export$e655ef011c4aa1a2 = "#FAFBFC";
var $2ed57f8980281ebc$export$9fdfb749e33cdf97 = "#F4F5F7";
var $2ed57f8980281ebc$export$3e51e8f1440314ba = "#EBECF0";
var $2ed57f8980281ebc$export$1ce2d1575d444ceb = "#DFE1E6";
var $2ed57f8980281ebc$export$8754fc7e6d8b3000 = "#C1C7D0";
var $2ed57f8980281ebc$export$c2e91cbeada39b8b = "#B3BAC5";
var $2ed57f8980281ebc$export$5f71e19f3a7ad9de = "#A5ADBA";
var $2ed57f8980281ebc$export$eaa8c8a70ac22806 = "#97A0AF";
var $2ed57f8980281ebc$export$7c87d337fb91a97d = "#8993A4";
var $2ed57f8980281ebc$export$d6447c357493214f = "#7A869A";
var $2ed57f8980281ebc$export$f563ee71e9ee74cd = "#6B778C";
var $2ed57f8980281ebc$export$e2ef2124cf4024b1 = "#5E6C84";
var $2ed57f8980281ebc$export$eece5f492e429f08 = "#505F79";
var $2ed57f8980281ebc$export$c39c0fe0f26207ae = "#42526E";
var $2ed57f8980281ebc$export$7090862dc3038a9f = "#344563";
var $2ed57f8980281ebc$export$ad0bacf983b7ddaa = "#253858";
var $2ed57f8980281ebc$export$7d61b15e0da132af = "#172B4D";
var $2ed57f8980281ebc$export$fbda843f0a27fe96 = "#091E42";
var $2ed57f8980281ebc$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $2ed57f8980281ebc$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $2ed57f8980281ebc$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $2ed57f8980281ebc$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $2ed57f8980281ebc$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $2ed57f8980281ebc$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $2ed57f8980281ebc$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $2ed57f8980281ebc$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $2ed57f8980281ebc$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $2ed57f8980281ebc$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $2ed57f8980281ebc$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $2ed57f8980281ebc$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $2ed57f8980281ebc$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $2ed57f8980281ebc$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $2ed57f8980281ebc$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $2ed57f8980281ebc$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $2ed57f8980281ebc$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $2ed57f8980281ebc$export$2f6319cf7d736c2a = "#E6EDFA";
var $2ed57f8980281ebc$export$95126bc8884d6634 = "#DCE5F5";
var $2ed57f8980281ebc$export$8338d8c35d44ff1 = "#CED9EB";
var $2ed57f8980281ebc$export$5368d76ae4fbbda7 = "#B8C7E0";
var $2ed57f8980281ebc$export$9f0a771d16ec8d36 = "#ABBBD6";
var $2ed57f8980281ebc$export$abcf8c38338b4aa5 = "#9FB0CC";
var $2ed57f8980281ebc$export$97e81faa16a182c7 = "#8C9CB8";
var $2ed57f8980281ebc$export$bfe21c59123ecf33 = "#7988A3";
var $2ed57f8980281ebc$export$ee82aa2ea6a1558 = "#67758F";
var $2ed57f8980281ebc$export$682927c6ed76be02 = "#56637A";
var $2ed57f8980281ebc$export$91fd9994c5be9757 = "#455166";
var $2ed57f8980281ebc$export$d281fbfe3cff2df6 = "#3B475C";
var $2ed57f8980281ebc$export$3902c91d8b98a753 = "#313D52";
var $2ed57f8980281ebc$export$8e8133c1ba5845b5 = "#283447";
var $2ed57f8980281ebc$export$33ff357f6620b39 = "#202B3D";
var $2ed57f8980281ebc$export$633847cf062b69e0 = "#1B2638";
var $2ed57f8980281ebc$export$9776a6e503bdbf76 = "#121A29";
var $2ed57f8980281ebc$export$6c813d5160dff5db = "#0E1624";
var $2ed57f8980281ebc$export$3d4f271a500072a = "#0D1424";
var $2ed57f8980281ebc$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $2ed57f8980281ebc$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $2ed57f8980281ebc$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $2ed57f8980281ebc$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $2ed57f8980281ebc$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $2ed57f8980281ebc$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $2ed57f8980281ebc$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $2ed57f8980281ebc$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $2ed57f8980281ebc$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $2ed57f8980281ebc$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $2ed57f8980281ebc$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $2ed57f8980281ebc$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $2ed57f8980281ebc$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $2ed57f8980281ebc$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $2ed57f8980281ebc$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $2ed57f8980281ebc$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $2ed57f8980281ebc$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $2ed57f8980281ebc$export$d2adc5dedf09fced = "#292A2E";
var $2ed57f8980281ebc$export$f51762073d2bb381 = "#94C748";
var $2ed57f8980281ebc$export$95e26d54def96891 = "#B3DF72";

});



//# sourceMappingURL=view.bbbda22f.js.map
